import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRiseupComponent } from './simple-icons-riseup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRiseupComponent ],
    exports:      [ SimpleIconsRiseupComponent ],
    bootstrap:    []
})
export class SimpleIconsRiseupModule {}
